import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, message, Space, Tag } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useCareerPath } from "Hooks/AdminHooks/Organization/useCareerPath";
export const CreateCareerPath = () => {
  const {
    formData,
    setFormData,
    createCareerPath,
    updateCareerPath,
    fetchCareerPath,
    careerPath,
    loadingEdit,
    loadingDomains,
    domains,
    fetchDomains,
  } = useCareerPath();

  const { departmentId, careerPathId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedDomainsIds, setSelectedDomainIds] = useState([]);

  useEffect(() => {
    fetchDomains();
    console.log("Domains", domains);

    if (careerPathId) {
      fetchCareerPath(careerPathId);
    }
  }, [careerPathId]);

  useEffect(() => {
    if (careerPathId && careerPath && domains.length > 0) {
      setFormData({
        name: careerPath.name || "",
        description: careerPath.description || "",
        departmentId: parseInt(careerPath.department.id),
      });
      setSelectedDomainIds(careerPath.domainKnowledges?.map((d) => d.domainKnowledgeId) || []);
    }
  }, [careerPathId, careerPath, departmentId]);

  const handleSelectDomain = (e) => {
    const domainId = Number(e.target.value);
    if (!domainId) return;
    if (!selectedDomainsIds.includes(domainId)) {
      setSelectedDomainIds((prev) => [...prev, domainId]);
    }
    e.target.value = "";
  };

  const removeDomain = (id) => {
    setSelectedDomainIds(selectedDomainsIds.filter((domain) => domain !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (careerPathId) {
        // UPDATE
        const payload = {
          id: parseInt(careerPathId),
          name: formData.name,
          description: formData.description,
          departmentId: formData.departmentId,
          domainKnowledgeIds: selectedDomainsIds,
        };
        console.log("payload", payload);
        const result = await updateCareerPath(payload);

        if (result && result.name) {
          message.success("Career Path updated successfully");

          setFormData({
            name: "",
            description: "",
            departmentId: parseInt(departmentId),
          });

          setTimeout(() => {
            navigate(`/department-detail/${careerPath.departmentId}`);
          }, 2000);
        }
      } else {
        // CREATE
        const payload = {
          name: formData.name,
          description: formData.description,
          departmentId: parseInt(departmentId),
          domainKnowledgeIds: selectedDomainsIds,
        };

        const result = await createCareerPath(payload);

        if (result && result.name) {
          message.success("Career Path created successfully");

          setFormData({
            name: "",
            description: "",
            departmentId: parseInt(departmentId),
          });

          setTimeout(() => {
            if (location.state?.returnTo === "department-detail") {
              navigate(`/department-detail/${location.state.departmentId}`);
            } else {
              navigate("/organization/career-paths", {
                state: {
                  departmentId: location.state?.departmentId || departmentId,
                },
              });
            }
          }, 2000);
        }
      }
    } catch (error) {
      console.error(error?.response);
      message.error(error.response?.data?.details || error.message);
    }
  };

  if (loadingEdit && careerPathId) {
    return <div>Loading...</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div style={{ padding: "24px", maxWidth: "600px", margin: "0 auto" }}>
        <h2 className="fw-bold mb-4">
          {careerPathId ? "Update Career Path" : "Create Career Path"}
        </h2>

        <form onSubmit={handleSubmit}>
          {/* Name */}
          <div className="mb-3">
            <label className="form-label mb-1">Name</label>
            <input
              className="form-control"
              type="text"
              value={formData.name || ""} // ✅ FIXED
              placeholder="Enter Career Path Name"
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
          </div>

          {/* Description */}
          <div className="mb-3">
            <label className="form-label mb-1">Description</label>
            <textarea
              className="form-control"
              rows="3"
              value={formData.description || ""} // ✅ FIXED
              placeholder="Enter Description"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  description: e.target.value,
                })
              }
            />
          </div>

          {/* Domains */}
          <div className="mb-3">
            <label className="form-label mb-1">Select Domains</label>
            <select className="form-select" defaultValue="" onChange={handleSelectDomain}>
              <option value="">
                {domains.length === 0 ? "No Domains Available" : "Select Domains Knowledge"}
              </option>
              {domains.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name} ({d.industry})
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4" style={{ marginTop: "10px" }}>
            <Space size={[8, 8]} wrap>
              {selectedDomainsIds.map((id) => {
                const domain = domains.find((d) => d.id === id);
                return (
                  <Tag
                    key={id}
                    closable
                    color="gold"
                    onClose={() => removeDomain(id)}
                    style={{ padding: "4px 10px", borderRadius: "4px" }}
                  >
                    {domain?.name} <small className="opacity-50">| {domain?.industry}</small>
                  </Tag>
                );
              })}
            </Space>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button size="large" onClick={() => navigate(-1)}>
              Cancel
            </Button>

            <Button size="large" className="btn-primary" htmlType="submit">
              {careerPathId ? "Update" : "Save"}
            </Button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default CreateCareerPath;
